/* @flow */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_IMAGE': {
        const { blockIdx, url, dimensions } = action.value
        draft.features[blockIdx].imgUrl = url
        draft.features[blockIdx].imgDimensions = dimensions || {}
        draft.features[blockIdx].imgCropParams = {}
        break
      }
      case 'ADD_BLOCK':
        draft.features.push(initialState.features[0])
        break
      case 'REMOVE_BLOCK':
        const { idx } = action.value
        draft.features.splice(idx, 1)
        break
      case 'CHANGE_BLOCK_TITLE': {
        const { idx, title } = action.value
        draft.features[idx].title = title
        break
      }
      case 'SET_IMG_CROP_PARAMS': {
        const { imgCropParams, blockIdx } = action.value
        draft.features[blockIdx].imgCropParams = imgCropParams
        break
      }
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE': {
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      }
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
    }
  })
}
